import { router, Stack } from 'expo-router';
import React from 'react';

import HeaderButton from '@molecules/HeaderButton';
import type { DrawerNavigationProp } from '@react-navigation/drawer';

import { Menu01Icon, PlusSignIcon } from '@hugeicons/core-free-icons';
import { headerOptionsCreator } from '@utils/screenOptions';

export default function Layout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={headerOptionsCreator(
          <HeaderButton<DrawerNavigationProp<never>>
            icon={Menu01Icon}
            onPress={(_, navigation) => {
              navigation.openDrawer();
            }}
          />,
          <HeaderButton
            icon={PlusSignIcon}
            onPress={() => {
              router.navigate('/newMessage');
            }}
          />,
        )}
      />
      <Stack.Screen
        name="[conversationId]"
        options={headerOptionsCreator(
          <HeaderButton onPress={() => router.navigate('/inbox/introduced')} />,
        )}
      />
    </Stack>
  );
}
